module.exports = __webpack_public_path__ + "media/newstyle/images/icon-print-orange-24e607eeaf7f8884cc38e28e3b71c0b5.svg";